import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Menu, X, User, LogOut } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import { useAuth } from '../contexts/AuthContext';

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { getItemCount } = useCart();
  const { user, logout } = useAuth();

  const navLinks = [
    { to: '/', label: 'Pradžia' },
    { to: '/apie', label: 'Apie mane' },
    { to: '/paslaugos', label: 'Paslaugos' },
    { to: '/mokymai', label: 'Mokymai' },
    { to: '/sesijos', label: 'Konsultacijos' },
    { to: '/parduotuve', label: 'Parduotuvė' },
    { to: '/kontaktai', label: 'Kontaktai' }
  ];

  return (
    <nav data-testid="main-navigation" className="glass-nav sticky top-0 z-50">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" data-testid="logo-link" className="flex items-center space-x-3">
            <img 
              src={`${process.env.REACT_APP_BACKEND_URL}/api/files/brand/logo.png`}
              alt="TavoEmocijos" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
                className="text-slate-700 hover:text-[#4CAF50] font-medium transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Right side actions */}
          <div className="flex items-center space-x-4">
            {user ? (
              <div className="hidden lg:flex items-center space-x-4">
                <Link
                  to="/profilis"
                  data-testid="profile-link"
                  className="flex items-center space-x-2 text-slate-700 hover:text-[#4CAF50]"
                >
                  <User className="w-5 h-5" />
                  <span>{user.full_name}</span>
                </Link>
                <button
                  onClick={logout}
                  data-testid="logout-button"
                  className="text-slate-700 hover:text-[#4CAF50]"
                >
                  <LogOut className="w-5 h-5" />
                </button>
              </div>
            ) : (
              <Link
                to="/prisijungti"
                data-testid="login-link"
                className="hidden lg:block bg-[#4CAF50] text-white hover:bg-[#43A047] rounded-full px-6 py-2 font-medium transition-colors"
              >
                Prisijungti
              </Link>
            )}

            <Link
              to="/krepselis"
              data-testid="cart-link"
              className="relative p-2 hover:bg-slate-100 rounded-full transition-colors"
            >
              <ShoppingBag className="w-6 h-6 text-slate-700" />
              {getItemCount() > 0 && (
                <span data-testid="cart-count" className="absolute -top-1 -right-1 bg-[#FF9F43] text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                  {getItemCount()}
                </span>
              )}
            </Link>

            {/* Mobile menu button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-toggle"
              className="lg:hidden p-2 hover:bg-slate-100 rounded-lg transition-colors"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div data-testid="mobile-menu" className="lg:hidden py-4 border-t border-slate-200">
            <div className="flex flex-col space-y-4">
              {navLinks.map(link => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-slate-700 hover:text-[#4CAF50] font-medium py-2"
                >
                  {link.label}
                </Link>
              ))}
              {!user && (
                <Link
                  to="/prisijungti"
                  onClick={() => setMobileMenuOpen(false)}
                  className="bg-[#4CAF50] text-white rounded-full px-6 py-3 font-medium text-center"
                >
                  Prisijungti
                </Link>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
